import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { withLocale } from '../../../TranslatorContext';

class UserEmailFormPlaceholder extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    render() {
        return (
            <Container>
                <Row>
                    <Col xs="12" md={{ size: 8, offset: 2 }}>
                        <h2 className="heading-3">
                            {this.props.t('settings/profile')}
                        </h2>
                        <p className="placeholder mb-0">email</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withLocale(UserEmailFormPlaceholder);
